import {combineReducers, configureStore} from "@reduxjs/toolkit";
import {combineEpics, createEpicMiddleware} from "redux-observable";
import {thunk} from "redux-thunk";

import reducers from "../reducers/reducers";
import epics from "../epics/epics";
import socketMiddleware from "./socketMiddleware";

export const buildStore = () => {
    const rootReducer = combineReducers(reducers);
    const rootEpic = combineEpics(...epics);

    const epicMiddleware = createEpicMiddleware();

    const store = configureStore({
        reducer: rootReducer,
        /* eslint-disable-next-line no-undef */
        devTools: process.env.NODE_ENV === "development",
        middleware: () => [socketMiddleware, epicMiddleware, thunk]
    });

    epicMiddleware.run(rootEpic);

    return store;
};
